export default "/assets/website/images/fb.svg?55d446a132fcab0d85465220c6c2a7b8";